<template>
  <div id="browser-check" class="danger text-danger" v-if="!isValidBrowser && browserName"
       style="padding: 15px 30px;background-color: #fcf9e9; font-size:1.3em; position: fixed;top:55px;width: 100%;z-index: 1001">
    <div class="col-xs-11">
      <i class="fa fa-warning text-danger"></i>
      <span style="margin-left: 15px;font-weight: 600;">
        {{browserName}} isn't officially supported by IdeXlab. Some features may not work properly unless you change browsers.
          </span>
    </div>
    <div class="col-xs-1 text-right" style="font-weight: normal;">
      <a class="closebox" @click="close"><i class="fa fa-times"></i></a>
    </div>
  </div>
</template>

<script>
import * as Bowser from 'bowser'

export default {
  name: 'browserCheck',
  data () {
    return {
      browserName: null,
      isValidBrowser: false
    }
  },
  beforeMount () {
    if (localStorage.getItem('browser-check') !== 'close') {
      const browser = Bowser.getParser(window.navigator.userAgent)

      this.browserName = browser.getBrowserName()

      this.isValidBrowser = browser.satisfies({
        chrome: '>=40',
        chromium: '>=40',
        firefox: '>=35',
        opera: '>=27',
        safari: '>=8',
        edge: '>=20'
      })
    }
  },
  methods: {
    close (event) {
      event.preventDefault()

      $('#browser-check').remove()
      localStorage.setItem('browser-check', 'close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/browserCheck.vue